module.exports = __webpack_public_path__ + "static/media/deleteAction.d3c06c55.svg";